import React from 'react';
import PropTypes from 'prop-types';

import { Tag, Text } from '@pinpoint/design-kit';
import CONSTANTS from 'src/store/constants';

function DeprecatedTag({ tag, ...rest }) {
  if (!tag) return null;

  return (
    <Tag
      p={{ x: '.375rem', y: '.188rem' }}
      // @ts-ignore
      h="1.125rem"
      textColor="grey"
      borderColor="grey"
      border="1px solid"
      data-tip={`Uses a ${CONSTANTS.PLATFORM.TAG_NAME[tag]} refresh platform`}
      {...rest}
    >
      <Text textSize="small">{CONSTANTS.PLATFORM.TAG[tag]}</Text>
    </Tag>
  );
}

DeprecatedTag.defaultProps = {
  tag: null,
};

DeprecatedTag.propTypes = {
  tag: PropTypes.string,
};

export default DeprecatedTag;
